"use client";

/* 
  Show Contributer component is used to show the author name and foolow author button
  This component accepts following proptypes.
  @param Book - Book detail
  @param SiteId - siteId
*/

import React, { useState } from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import AuthorRoles from "../constants/AuthorRoles";
import FollowButton from "./FollowButton/FollowButton";
import { getSubstring, decodeHtmlEntities } from "../helpers/Helper";
import { useAppContext } from "./Provider";
import styles from "./ShowContributor.module.css";

const formatAuthors = (
  authors,
  primary_isbn,
  siteId,
  beforeText,
  showFollowAuthor,
  eventName,
  isLazyLoadFollowIcon,
  authorOpen,
  hideAuthorAfterTwo,
  classes
) => {
  let displayedAuthors = [];
  let hideAuthor = false;
  if (authors) {
    let primaryAuthors = authors.filter(primaryAuthorCheck);
    if (primaryAuthors.length > 0) {
      primaryAuthors.map((author, key) => {
        hideAuthor = key > 1 && hideAuthorAfterTwo === true ? true : false;
        displayedAuthors.push(
          authorDisplay(
            author,
            key,
            primary_isbn,
            siteId,
            beforeText,
            showFollowAuthor,
            eventName,
            isLazyLoadFollowIcon,
            authorOpen,
            hideAuthor,
            classes
          )
        );
      });
    } else {
      let author = authors[0];
      displayedAuthors.push(
        authorDisplay(
          author,
          0,
          primary_isbn,
          siteId,
          beforeText,
          showFollowAuthor,
          eventName,
          isLazyLoadFollowIcon,
          authorOpen,
          hideAuthor,
          classes
        )
      );
    }
    return displayedAuthors;
  }
};

const primaryAuthorCheck = (author) => {
  if (author.role === AuthorRoles.PRIMARY) {
    return true;
  }
};

const authorDisplay = (
  author,
  key,
  primary_isbn,
  siteId,
  beforeText,
  showFollowAuthor,
  eventName,
  isLazyLoadFollowIcon,
  authorOpen,
  hideAuthor,
  classes
) => {
  let displayName = author?.display_name;
  let className = "";
  if (displayName) {
    displayName = decodeHtmlEntities(displayName);
    className =
      authorOpen === true && hideAuthor === true ? "singleAuthor hideFollowAuthor" : "singleAuthor";
  } else {
    if (author?.first_name && author?.last_name) {
      displayName = decodeHtmlEntities(author.first_name + " " + author.last_name);
    }
  }

  return (
    <React.Fragment key={author?.firebrand_id || author?.slug || key}>
      <div className={className ? className : classes}>
        {key == 0 && beforeText ? (
          <span className={styles["before-text"]}> {beforeText} </span>
        ) : (
          ""
        )}
        {author?.slug ? (
          <Link href={`/contributor/${author.slug}`}>{getSubstring(displayName, 22)}</Link>
        ) : (
          <span className="primarySpan" key={key}>
            {getSubstring(displayName, 22)}
          </span>
        )}
        {showFollowAuthor === true ? (
          <FollowButton
            eventName={eventName}
            titleISBN={primary_isbn}
            author={displayName}
            authorId={author?.firebrand_id}
            siteId={siteId}
            isLazyLoad={isLazyLoadFollowIcon}
            autherInfoIconStyles={styles["author-info-icon"]}
          />
        ) : (
          ""
        )}
      </div>
      <style>
        {`
          .singleAuthor.hideFollowAuthor {
            display: none;
          }
          .singleAuthor {
            margin-bottom: 8px;
          }
          .singleAuthor:not(:first-child) {
            margin-left: 6px;
          }

          .singleAuthor .primarySpan {
            font-weight: normal;
          }
          @media (max-width: 575px) {
            .singleAuthor {
              display: flex;
              margin-top: 5px;
              margin-bottom: 5px;
              // justify-content: space-between;
              align-items: center;
            }
            .singleAuthor .primarySpan {
              display: inline-flex;
              margin-right: 5px;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export const ShowContributor = (props) => {
  const { isMobile } = useAppContext();
  const [authorOpen, setAuthorOpen] = useState(true);
  let showMoreToggle = () => {
    setAuthorOpen(!authorOpen);
  };

  let Book = props.Book;
  let ShowFollowAuthor = props.ShowFollowAuthor;
  if (Book && Book.authors) {
    let updatedAuthors = formatAuthors(
      Book.authors,
      Book.primary_isbn,
      props.SiteId,
      props.BeforeText,
      ShowFollowAuthor,
      props.EventName,
      props.IsLazyLoadFollowIcon,
      authorOpen,
      props.HideAuthorAfterTwo,
      props.classes
    );
    let totalAuthor = updatedAuthors.length;
    if (updatedAuthors.length) {
      //add comma between author names
      updatedAuthors = updatedAuthors.reduce((prev, curr) => [prev, " ", curr]);
      return (
        <div className={`show-contributor ${props.Class ? styles["book-card"] : "show-inline"}`}>
          <div className={styles["book-details-authors"]}>{updatedAuthors}</div>
          {totalAuthor > 2 && props.RenderShowMoreAuthor ? (
            <p
              className={`${styles["view-more-button"]} ${authorOpen == true ? styles["view-more-icon"] : styles["view-less-icon"]}`}
              onClick={showMoreToggle}
            >
              <a onClick={(e) => e.preventDefault()}>
                {" "}
                {isMobile == true
                  ? authorOpen == true
                    ? "Show More"
                    : "Show Fewer"
                  : authorOpen == true
                    ? "Show More Authors"
                    : "Show Fewer Authors"}{" "}
              </a>{" "}
            </p>
          ) : (
            ""
          )}
        </div>
      );
    }
  }
};

// ShowContributor.defaultProps = {
//   ShowFollowAuthor: true,
//   RenderShowMoreAuthor: false,
//   IsLazyLoadFollowIcon: true,
//   HideAuthorAfterTwo: false,
// };

ShowContributor.propTypes = {
  Book: PropTypes.object.isRequired,
  SiteId: PropTypes.number.isRequired,
  ShowFollowAuthor: PropTypes.bool,
  RenderShowMoreAuthor: PropTypes.bool,
  EventName: PropTypes.string,
  IsLazyLoadFollowIcon: PropTypes.bool,
  HideAuthorAfterTwo: PropTypes.bool,
};

export default ShowContributor;
